import { getErrorsFromCheckout } from '../../common/utils/checkoutUtils.js';
import { getErrorsFromUpsertDeliveryAddress } from '../../common/utils/errorUtils.js';
import { getErrorsFromUpdateUserDetails } from '../../components/UserDetails/userDetailsUtils.js';
import { TypeKeys } from '../actions/index.js';
import { updateActionStatePhase } from '../common/index.js';
import { ActionPhase } from '../common/storeUtils.js';
import { reduceCrudAction } from './reducerUtils.js';
import type { OnlineOrderState } from '../../common/types/states.js';
import type { ActionTypes } from '../actions/index.js';
import type { ActionsHistory } from '../common/store.js';

export function onlineOrderReducer(
  state: (ActionsHistory & OnlineOrderState) | undefined | null,
  action: ActionTypes
): (OnlineOrderState & ActionsHistory) | null {
  if (typeof state === 'undefined') {
    return null;
  }

  switch (action.type) {
    case TypeKeys.SUBMIT_ONLINE_ORDER: {
      if (action.overridePreviousAction) {
        const actions = updateActionStatePhase(
          TypeKeys.SUBMIT_ONLINE_ORDER,
          state!,
          ActionPhase.IN_PROGRESS,
          ActionPhase.SUCCESS
        );

        return {
          actions: actions
            ? [
                ...actions,
                {
                  phase: ActionPhase.IN_PROGRESS,
                  value: action,
                },
              ]
            : undefined,
          saving: true,
        };
      }

      if (action.contactPerson) {
        const contactPersonErrors = getErrorsFromUpdateUserDetails(
          action.contactPerson,
          action.customerType,
          action.contactPersonValidationErrors
        );
        if (contactPersonErrors) {
          return {
            ...state,
            saving: false,
            errors: contactPersonErrors,
          };
        }
      }

      const deliveryAddressErrors = getErrorsFromUpsertDeliveryAddress(
        action.deliveryAddress,
        action.isCompanyNameRequired
      );
      const deviceCheckoutErrors = getErrorsFromCheckout(
        action.approverContact,
        action.personBillingAddress,
        action.personBillingEmail
      );

      if (deviceCheckoutErrors) {
        return {
          ...state,
          saving: false,
        };
      }
      if (deliveryAddressErrors) {
        if (deliveryAddressErrors) {
          return {
            ...state,
            errors: deliveryAddressErrors,
            saving: false,
          };
        }
        return {
          ...state,
          errors: undefined,
          saving: false,
        };
      } else {
        return {
          ...reduceCrudAction(action, state),
          saving: true,
        };
      }
    }

    case TypeKeys.SUBMIT_ONLINE_ORDER_FULFILLED: {
      return {
        ...state,
        actions: updateActionStatePhase(
          TypeKeys.SUBMIT_ONLINE_ORDER,
          state!,
          ActionPhase.IN_PROGRESS,
          ActionPhase.SUCCESS
        ),
        saving: false,
      };
    }

    case TypeKeys.SUBMIT_ONLINE_ORDER_FAILED: {
      return {
        ...state,
        actions: updateActionStatePhase(
          TypeKeys.SUBMIT_ONLINE_ORDER,
          state!,
          ActionPhase.IN_PROGRESS,
          ActionPhase.FAILED
        ),
        saving: false,
      };
    }

    case TypeKeys.POLL_FOR_CREDIT_CHECK: {
      return {
        ...reduceCrudAction(action, state),
        saving: true,
      };
    }

    case TypeKeys.POLL_FOR_CREDIT_CHECK_V2_FULFILLED: {
      const actions = updateActionStatePhase(
        TypeKeys.POLL_FOR_CREDIT_CHECK,
        state!,
        ActionPhase.IN_PROGRESS,
        ActionPhase.SUCCESS
      );

      return {
        ...state,
        actions,
        saving: false,
      };
    }

    case TypeKeys.POLL_FOR_CREDIT_CHECK_FAILED: {
      // Cannot know the state of the credit check -> cannot know if the order is processed or not
      return {
        ...state,
        actions: updateActionStatePhase(
          TypeKeys.POLL_FOR_CREDIT_CHECK,
          state!,
          ActionPhase.IN_PROGRESS,
          ActionPhase.FAILED
        ),
        saving: false,
      };
    }

    default:
      return state;
  }
}
